import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService, DateUtils } from 'ng-jhipster';

import { ClassTypeService } from '../class-type/class-type.service';
import { LocationService, Location } from '../location';
import { Lesson, LessonWithContextDetails, LessonStatus, LessonUtilService, LessonService } from '.';
import { Card, CardService } from '../card';
import { Reservation, ReservationStatus } from '../reservation/reservation.model';
import { ReservationService } from '../reservation/reservation.service';
import { ReservationUtilService } from '../reservation/reservation.util.service';
import { StudentService } from '../../entities/student/student.service';
import { StudentUtilService } from '../../entities/student/student.util.service';
import { Student } from '../student/student.model';
import { NewsArticle } from '../news-article/news-article.model';
import { NewsArticleService } from '../news-article/news-article.service';
import { ITEMS_PER_PAGE, Principal, CRUD_ACTIONS, DateUtilities } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';
import { ClassType, ClassTypeUtilService } from '../class-type/index';
import { School, SchoolService } from '../school';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';

import { HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Component({
    selector: 'jhi-lesson',
    templateUrl: './lesson.component.html'
})
export class LessonComponent implements OnInit, OnDestroy {
    public static readonly RESERVATION_STATUS_CANCELLED_AS_STRING: any = 'CANCELLED';
    public static readonly CARD_BEGINING_FIELD_NAME = 'validSince';

    availableLessonStatuses = [
        {id: LessonStatus.OPEN, value: 'OPEN'},
        {id: LessonStatus.EXECUTED, value: 'EXECUTED'},
        {id: LessonStatus.CANCELLED, value: 'CANCELLED'}
    ];

    school: School;
    classTypes: ClassType[];
    locations: Location[];
    teachers: Student[];
    currentAccount: any;
    currentStudent: Student;
    currentUserIsStudent = false;
    lessons: LessonWithContextDetails[];
    // Used to have a state and show the spinner when creating a reservation
    isProcessingReservationForCurrentUser: Map<number, boolean> = new Map();
    currentStudentReservationsCount: number;
    currentStudentReservations: Reservation[];
    currentStudentCards: Card[];
    error: any;
    success: any;
    lessonListModificationSubscription: Subscription;
    lessonBulkCreationSubscription: Subscription;
    lessonBulkDeletionSubscription: Subscription;
    lessonBulkUpdateSubscription: Subscription;
    currentLessonsSearch: string;
    currentSearchByDateFrom: NgbDateStruct;
    currentSearchByDateTo: NgbDateStruct;
    currentSearchByClassType: string;
    currentSearchByLocation: string;
    currentSearchByTeacher: string;
    currentSearchByLessonStatus: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;
    news: NewsArticle[];
    isSearchBarCollapsed = true;
    bookingWindow: number;

    // variables to manage lesson privileges
    hasAdvancedTeacherPrivileges: boolean;
    hasSchoolAdminPrivileges: boolean;

    // variables to show free trial
    showCelebrationMessage: boolean;

    constructor(
        private classTypeService: ClassTypeService,
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        private reservationService: ReservationService,
        private studentService: StudentService,
        private studentUtilService: StudentUtilService,
        private locationService: LocationService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: EventManager,
        private paginationUtil: PaginationUtil,
        private paginationConfig: PaginationConfig,
        private dateUtils: DateUtils,
        private cardService: CardService,
        private reservationUtilService: ReservationUtilService,
        private newsArticleService: NewsArticleService,
        private schoolService: SchoolService,
        private classTypeUtilService: ClassTypeUtilService
    ) {
        this.jhiLanguageService.setLocations(['school', 'lesson', 'lessonStatus', 'lessonFamily', 'reservation',
                                              'reservationStatus', 'newsArticle', 'location', 'classType', 'backoffice']);
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe((data) => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });

         this.activatedRoute.queryParams.subscribe((params) => {
            if (params['freeTrial'] === 'true') {
            // Show celebratory message or banner
            this.showCelebrationMessage = true;
            }
        });

        this.currentLessonsSearch = activatedRoute.snapshot.params['search']
            ? activatedRoute.snapshot.params['search']
            : '';

        // we have to set the values on the filters to reflect the current search if any
        if (this.currentLessonsSearch) {
                let snapshotParams = activatedRoute.snapshot.params;

                if (snapshotParams['yearFrom'] && snapshotParams['monthFrom'] && snapshotParams['dayFrom']) {
                    this.currentSearchByDateFrom = {
                        year: parseInt(snapshotParams['yearFrom'], 10),
                        month:  parseInt(snapshotParams['monthFrom'], 10),
                        day:  parseInt(snapshotParams['dayFrom'], 10)
                    };
                }

                if (snapshotParams['yearTo'] && snapshotParams['monthTo'] && snapshotParams['dayTo']) {
                    this.currentSearchByDateTo = {
                        year: parseInt(snapshotParams['yearTo'], 10),
                        month:  parseInt(snapshotParams['monthTo'], 10),
                        day:  parseInt(snapshotParams['dayTo'], 10)
                    };
                }

            this.currentSearchByLessonStatus = snapshotParams['lessonStatus'];
            this.currentSearchByClassType = snapshotParams['classType'];
            this.currentSearchByLocation = snapshotParams['location'];
            this.currentSearchByTeacher = snapshotParams['teacher'];
        }
    }

    ngOnInit() {
        forkJoin([
            this.schoolService.findCurrent(),
            this.studentService.getCurrent(),
            fromPromise(this.principal.identity()),
            fromPromise(this.principal.hasOnlyAuthority('ROLE_USER'))
        ]).subscribe(
            ([school, student, account, currentUserIsStudent]) => {
                this.school = school;
                this.currentStudent = student;
                this.currentUserIsStudent = currentUserIsStudent;

                if (currentUserIsStudent) {
                    this.initCurrentSearch(true);
                } else {
                    if (!this.currentLessonsSearch) {
                        this.initCurrentSearch(false);
                    }
                }

                this.currentAccount = account;

                this.activatedRoute.params.subscribe((params) => {
                        this.loadLessons();
                });
            },
            (error) => this.onError(error)
        );
        this.loadNews();
        this.loadClassTypesList();
        this.loadLocationList();
        this.loadTeachersList();
        this.registerChangeInLessons();
        this.loadLessonAdminRights();
    }

    loadLessonAdminRights() {
        this.principal.identity().then((account) => {
            this.principal
            .hasAnyAuthority(['ROLE_ADVANCED_TEACHER'])
            .then((response) => {
                this.hasAdvancedTeacherPrivileges = response;
            });
        });

        this.principal.identity().then((account) => {
            this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN'])
            .then((response) => {
                this.hasSchoolAdminPrivileges = response;
            });
        });
    }

    ngOnDestroy() {
        this.lessonListModificationSubscription.unsubscribe();
        this.lessonBulkCreationSubscription.unsubscribe();
        this.lessonBulkDeletionSubscription.unsubscribe();
        this.lessonBulkUpdateSubscription.unsubscribe();
    }

    loadLessons() {
        if (!this.currentStudent || !this.school) {
            console.log('current student and school are not present, cannot load lessons');
            return;
        }

        if (this.currentStudent.maxDaysToShowInLessonsLists < 1) {
            // dont load lessons because the user does not have the right to see less
            // than 1 days of lessons
            this.lessons = [];
            return;
        }

        if (this.currentLessonsSearch) {
            this.lessonService.search({
                query: this.currentLessonsSearch,
                size: this.itemsPerPage,
                sort: this.sort(),
                page: this.page - 1,
            })
            .subscribe(
                (res: HttpResponse<Lesson[]>) => this.onLessonsSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
            );

            return;
        }

        this.lessonService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        })
        .subscribe(
            (res: HttpResponse<Lesson[]>) => {
                this.onLessonsSuccess(res.body, res.headers);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        this.currentStudentReservationsCount = 0;
        this.router.navigate(['/lesson'], {
            queryParams:
            {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentLessonsSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadLessons();
    }

    clear() {
        this.currentStudentReservationsCount = 0;
        this.lessons = null;
        this.page = 0;
        this.initCurrentSearch(this.currentUserIsStudent);

        // reset URL if you want it clean
        this.router.navigate(['/lesson']);

        // force reload logic here
        this.loadLessons();
    }

    search() {
        this.currentStudentReservationsCount = 0;
        this.page = 0;
        this.currentLessonsSearch = this.getLessonsQuery();

        let params: any = {
            search: this.currentLessonsSearch,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc'),
            lessonStatus : this.currentSearchByLessonStatus,
            classType : this.currentSearchByClassType,
            location : this.currentSearchByLocation
        };

        if (this.currentSearchByDateFrom) {
            params.yearFrom = this.currentSearchByDateFrom.year;
            params.monthFrom = this.currentSearchByDateFrom.month;
            params.dayFrom = this.currentSearchByDateFrom.day;
        }

        if (this.currentSearchByDateTo) {
            params.yearTo = this.currentSearchByDateTo.year;
            params.monthTo = this.currentSearchByDateTo.month;
            params.dayTo = this.currentSearchByDateTo.day;
        }
        this.router.navigate(['/lesson', params]);
    }

    trackId(index: number, item: Lesson) {
        return item.id;
    }

    registerChangeInLessons() {
        this.lessonListModificationSubscription = this.eventManager
                                   .subscribe('lessonListModification',
                                        (response) => this.handleActionResult(response.content));

        this.lessonBulkDeletionSubscription = this.eventManager
                                    .subscribe('lessonBulkDeletion',
                                        (response) => {
                                            this.loadLessons();
                                        });
        this.lessonBulkUpdateSubscription = this.eventManager
                                    .subscribe('lessonBulkUpdate',
                                        (response) => {
                                            this.loadLessons();
                                        });

        this.lessonBulkCreationSubscription = this.eventManager
                                   .subscribe('lessonBulkCreation',
                                        (response) => {
                                            let dateFrom = response['content']['from'];
                                            let dateTo = response['content']['to'];
                                            if (!dateFrom || !dateTo) {
                                                return;
                                            }
                                            this.currentSearchByDateFrom = dateFrom ;
                                            this.currentSearchByDateTo = dateTo ;
                                            this.currentLessonsSearch = DateUtilities.getDateRangeQuery(
                                                LessonUtilService.LESSON_BEGINING_FIELD_NAME,
                                                dateFrom, dateTo);

                                            let params: any = {
                                                search: this.currentLessonsSearch,
                                                page: 0,
                                                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                                            };

                                            if (this.currentSearchByDateFrom) {
                                                params.yearFrom = this.currentSearchByDateFrom.year;
                                                params.monthFrom = this.currentSearchByDateFrom.month;
                                                params.dayFrom = this.currentSearchByDateFrom.day;
                                            }

                                            if (this.currentSearchByDateTo) {
                                                params.yearTo = this.currentSearchByDateTo.year;
                                                params.monthTo = this.currentSearchByDateTo.month;
                                                params.dayTo = this.currentSearchByDateTo.day;
                                            }

                                            this.router.navigate(['/lesson', params]);

                                            this.loadLessons();
                                        });
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'begining') {
            result.push('begining');
        }
        return result;
    }

    // Init the values of the components and the search query
    private initCurrentSearch(isStudent: boolean) {
        let fromDate = new Date();
        let toDate = new Date();

        let fromDateStruct: NgbDateStruct = {
            year: fromDate.getFullYear(),
            month : fromDate.getMonth() + 1,
            day : fromDate.getDate()
        };
        let toDateStruct: NgbDateStruct;

        this.currentSearchByClassType = '';
        this.currentSearchByLocation = '';
        this.currentSearchByTeacher = '';
        this.currentSearchByDateFrom = fromDateStruct;

        if (isStudent) {
            // We only show the OPEN and CANCELLED lessons from today to
            // a certain number of days configured in the student or school
            this.bookingWindow = this.getBookingWindow(this.school, this.currentStudent);

            toDate.setDate(fromDate.getDate() + this.bookingWindow );
            toDateStruct = {
                year: toDate.getFullYear(),
                month : toDate.getMonth() + 1,
                day : toDate.getDate()
            };

            this.currentSearchByDateTo = toDateStruct;
            this.currentSearchByLessonStatus = '!EXECUTED';
        } else {
            // the search of lessons  must be initialized
            // with the current week and 30 days
            toDate.setDate(fromDate.getDate() + 30);
            toDateStruct = {
                year: toDate.getFullYear(),
                month : toDate.getMonth() + 1,
                day : toDate.getDate()
            };

            this.currentSearchByDateTo = toDateStruct;
            this.currentSearchByLessonStatus = '';
        }

        this.currentLessonsSearch = this.getLessonsQuery();
    }

    getBookingWindow(school: School, student: Student): number {
        return this.studentUtilService.getBookingWindow(school, student);
    }

    handleBookButtonClick(lesson: LessonWithContextDetails): void {
        LessonUtilService.handleBookClick(lesson
            , this.cardService
            , () => this.createReservation(lesson)
            , (error) => this.onError(error)
            , this.router
        );
    }

    createReservation(lesson: LessonWithContextDetails) {
        let currentUserReservation: Reservation = lesson.currentStudentReservation;
        let copy: Reservation = currentUserReservation ? Object.assign({}, currentUserReservation) : null;
        this.isProcessingReservationForCurrentUser.set(lesson.id, true);

        if (!copy) {
            let reservation: Reservation = new Reservation();
            reservation.status = ReservationStatus.NEW;
            reservation.lesson = lesson;

            this.reservationService.create(reservation, undefined)
                .subscribe((res: Reservation) =>
                    this.onReservationCreateSuccess(res, lesson),
                (res: HttpErrorResponse) => this.onError(res, lesson.id));
        } else {
            copy.status = ReservationStatus.NEW;
            this.reservationService.update(copy, undefined)
                .subscribe(
                    (reservation: Reservation) => {
                        this.onReservationRenewSuccess(reservation, lesson);
                    },
                    (res: HttpErrorResponse) => {
                        this.onError(res, lesson.id);
                    }
                );
        }
    }

    cancelReservation(lesson: LessonWithContextDetails) {
        let reservation: Reservation = lesson.currentStudentReservation;

        let copy: Reservation = reservation ? Object.assign({}, reservation) : null;
        if (copy) {
            copy.status = ReservationStatus.CANCELLED;
            this.isProcessingReservationForCurrentUser.set(lesson.id, true);
            this.reservationService.update(copy, undefined)
                .subscribe((resrv: Reservation) =>
                    this.onReservationCancelSuccess(resrv, lesson),
                (res: HttpErrorResponse) => this.onError(res, lesson.id));
        }
    }

    getReservationStyle(lesson: LessonWithContextDetails): String {
        if (lesson.currentStudentReservation) {
            return this.reservationUtilService.getReservationStyle(
                lesson.currentStudentReservation.status.toString());
        }
        return 'text-info';
    }

    loadCurrentStudentReservations() {
        // We get the reservations of the current student for each lesson
        if (this.lessons && this.lessons.length > 0 && this.currentStudent) {
            let lessonIdsClause = '(';

            this.lessons.forEach((lesson, i) => {
                lessonIdsClause += i > 0 ? ' OR lesson.id:' + lesson.id : 'lesson.id:' + lesson.id;
            });
            lessonIdsClause += ') AND student.id:' + this.currentStudent.id;

            this.reservationService
            .count({ query: lessonIdsClause })
            .pipe(
                tap((count: number) => this.currentStudentReservationsCount = count),
                switchMap((count: number) => {
                    if (count > 0) {
                        return this.reservationService.search({
                        query: lessonIdsClause,
                        sort: [],
                        size: this.itemsPerPage
                        });
                    } else {
                        // return an empty response observable so success is still called
                        return of(new HttpResponse<Reservation[]>({ body: [], headers: new HttpHeaders() }));
                    }
                })
            )
            .subscribe({
                next: (res: HttpResponse<Reservation[]>) =>
                this.onCurrentStudentReservationsLoadSuccess(res.body, res.headers),
                error: (err: HttpErrorResponse) => this.onError(err)
            });
        }
    }

    loadCurrentStudentCards() {
        // We get the cards of the current student for the specified dates on the search
        if (this.lessons && this.lessons.length > 0 && this.currentStudent) {
            let cardsClause = DateUtilities.getDateRangeQuery(LessonComponent.CARD_BEGINING_FIELD_NAME,
                                     null, this.currentSearchByDateTo);
            cardsClause += ' AND ' + DateUtilities.getDateRangeQuery(LessonUtilService.CARD_ENDING_FIELD_NAME,
                this.currentSearchByDateFrom, null);
            cardsClause += ' AND student.id:' + this.currentStudent.id;
            this.cardService.count({
                query: cardsClause
            })
            .subscribe(
                (cardsCount: number) => {
                    if (cardsCount > 0) {
                        this.cardService.search({
                            query: cardsClause,
                            sort: [],
                            size: this.itemsPerPage
                        })
                        .subscribe(
                            (res: HttpResponse<Card[]>) => {
                                this.onCurrentStudentCardsLoadSuccess(res.body, res.headers);
                            },
                            (res: HttpErrorResponse) => {
                                this.onError(res);
                            }
                        );
                    }
                },
                (res: HttpErrorResponse) => {
                    this.onError(res);
                }
            );
        }
    }

    dateFromChanged(event) {
        // There is no action to take when dateFrom changes
    }

    /**
     * Returns true if all validations to activate the search button pass.
     */
    isSearchActive() {
            return DateUtilities.isDateRangeValid(this.currentSearchByDateFrom, this.currentSearchByDateTo, true);
    }

    disableButton(lesson: LessonWithContextDetails, buttonName: string): boolean {
        let reservation: Reservation = lesson.currentStudentReservation;
        let currentReservationStatus = reservation ? reservation.status : null;

        if (lesson.status as any !== 'OPEN' ) {
            return true;
        }

        if (currentReservationStatus as any === 'ATTENDED' || currentReservationStatus as any === 'NO_SHOW') {
                return true;
        }

        // TODO also check if the current school is accepting online payments
        if (buttonName === 'checkout') {
            if (!LessonUtilService.allowToPayOnline(this.school, lesson, this.currentStudent)) {
                return true;
            }

            return currentReservationStatus as any === 'NEW';
        }

        if (buttonName === 'book') {
            return currentReservationStatus as any === 'NEW';
        }

        if (buttonName === 'cancel') {
            // do not allow to cancel if the reservation has been payed
            // the reinboursement use case has not been yet developed
            return !currentReservationStatus ||
                currentReservationStatus as any === 'CANCELLED' ||
                this.reservationUtilService.isPayedOnLine(reservation) ;
        }

        if (this.isProcessingReservationForCurrentUser.get(lesson.id)) {
            return true;
        }

        return true;
    }

    showButton(lesson: LessonWithContextDetails, buttonName: string) {
        if (buttonName === 'book') {
            const showBookButton = LessonUtilService.allowCurrentStudentToBook(this.currentUserIsStudent, lesson);
            return showBookButton;
        }

        if (buttonName === 'checkout') {
            const showCheckoutButton = LessonUtilService.allowCurrentStudentToCheckout(this.currentUserIsStudent, lesson);
            return showCheckoutButton;
        }

        if (buttonName === 'recurrent-reservation') {
            return this.school ? this.school.recurrentReservationsModuleEnabled : false;
        }

        return false;
    }

    getStyle(index: number): any {
        return  index === 0 ||
        !this.isTheSameDateAsPreviousLesson(index)
        ? {'border-top': '2px solid gray'} : '';
    }

    getLabelForSmallDevices(value: string): string {
        return LessonUtilService.getLabelForSmallDevices(value);
    }

    getLessonStyle(lesson: Lesson) {
        return  {'color': LessonUtilService.getBackgroundColor(lesson)};
    }

    shouldPrintDate(index: number): boolean {
        return index === 0 || !this.isTheSameDateAsPreviousLesson(index);
    }

    private isTheSameDateAsPreviousLesson(index: number) {
        return this.lessons[index].begining.getDate() === this.lessons[index - 1].begining.getDate();
    }

    // returns the value of the query search using the components
    private getLessonsQuery() {
        let operators = [];

        if (this.currentSearchByDateFrom || this.currentSearchByDateTo) {
            operators.push(DateUtilities.getDateRangeQuery(LessonUtilService.LESSON_BEGINING_FIELD_NAME,
                this.currentSearchByDateFrom, this.currentSearchByDateTo));
        }

        if (this.currentSearchByClassType) {
            operators.push('classType.id:' + this.currentSearchByClassType);
        }

        if (this.currentSearchByLessonStatus) {
            if (this.currentSearchByLessonStatus.includes('!')) {
                operators.push('!(status:' + this.currentSearchByLessonStatus.replace('!', '') + ')');
            } else {
                operators.push('status:' + this.currentSearchByLessonStatus);
            }
        }

        if (this.currentSearchByLocation) {
            operators.push('location.id:' + this.currentSearchByLocation);
        }

        if (this.currentSearchByTeacher) {
            operators.push('teacher.id:' + this.currentSearchByTeacher);
        }

        return operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');
    }

    private onLessonsSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.lessons = (data || []).map(LessonWithContextDetails.fromLesson);

        if (this.currentStudent) {
            this.loadCurrentStudentReservations();
            this.loadCurrentStudentCards();
        }
    }

    private loadClassTypesList() {
        this.classTypeService.search({query: 'active:true'})
        .subscribe(
            (res: HttpResponse<ClassType[]>) => {
                this.classTypes = this.classTypeUtilService.orderClassTypesByName(res.body);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private loadLocationList() {
        this.locationService.search({query: 'active:true'})
        .subscribe(
            (res: HttpResponse<Location[]>) => {
                this.locations = res.body;
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private loadTeachersList() {
        this.studentService.queryTeachers()
        .subscribe(
            (res: HttpResponse<Student[]>) => {
                const teachersRaw = res.body;
                this.teachers = this.studentUtilService.orderStudentsByName(teachersRaw);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private onCurrentStudentReservationsLoadSuccess(data, headers) {
        this.currentStudentReservations = data;
        // Calculate the reservations for the current User for all lessons
        this.currentStudentReservations.forEach(reservation => {
            this.lessons.forEach(lesson => {
                if (reservation.lesson.id === lesson.id) {
                    lesson.currentStudentReservation = reservation;
                }
            });
        });
    }

    private onCurrentStudentCardsLoadSuccess(data, headers) {
        this.currentStudentCards = data;
        // Calculate the cards for the current User for all lessons
        // the card must be valid on the date and have available bookings
        this.lessons.forEach(lesson => {
            let lessonDate: Date = new Date();
            lessonDate.setDate(lesson.begining.getDate());
            lessonDate.setMonth(lesson.begining.getMonth());
            lessonDate.setFullYear(lesson.begining.getFullYear());
            lessonDate.setHours(0);
            lessonDate.setMinutes(0);
            lessonDate.setSeconds(0);
            lessonDate.setMilliseconds(0);

            this.currentStudentCards.forEach(card => {
                if (lessonDate >= card.validSince
                    && lessonDate <= card.validUntil) {
                    lesson.currentStudentCompatibleCards.push(card);
                }
            });
        });
    }

    private handleActionResult(result: { action: string, content: any }) {
        let entity: LessonWithContextDetails = result.content;
        let action: String = result.action;

        this.lessons.forEach((item, i) => {
                if (item.id === entity.id) {
                    switch (action) {
                        case CRUD_ACTIONS.UPDATE:
                            // we have to format the lesson before swaping
                            entity.begining = this.dateUtils
                                            .convertDateTimeFromServer(entity.begining);
                            entity.ending = this.dateUtils
                                            .convertDateTimeFromServer(entity.ending);

                            // We copy the currentStudentReservation and currentStudentCard before swaping
                            // because those fields does not come from the backend
                            entity.currentStudentReservation = item.currentStudentReservation;
                            entity.currentStudentCompatibleCards = item.currentStudentCompatibleCards;
                            this.lessons[i] = entity;
                            break;
                        case CRUD_ACTIONS.DELETE:
                            this.lessons.splice(i, 1);
                            break;
                    }
                }
            });
    }

    private onReservationCreateSuccess(reservation: Reservation, lesson: LessonWithContextDetails) {
        lesson.currentStudentReservation = reservation;
        this.isProcessingReservationForCurrentUser.delete(lesson.id);
        if (lesson.availablePlaces > 0) {
            lesson.availablePlaces--;
            lesson.bookings++;
        }
    }

    private onReservationRenewSuccess(reservation: Reservation, lesson: LessonWithContextDetails) {
        lesson.currentStudentReservation = reservation;
        this.isProcessingReservationForCurrentUser.delete(lesson.id);
        if (lesson.availablePlaces > 0) {
            lesson.availablePlaces--;
            lesson.bookings++;
        }
    }

    private onReservationCancelSuccess(reservation: Reservation, lesson: LessonWithContextDetails) {
        lesson.currentStudentReservation = reservation;
        this.isProcessingReservationForCurrentUser.delete(lesson.id);
        lesson.availablePlaces++;
        lesson.bookings--;
    }

    private onError(error: HttpErrorResponse, lessonId?: any) {
        if (lessonId) {
            this.isProcessingReservationForCurrentUser.delete(lessonId);
            this.lessonService.find(lessonId).subscribe(
                (res: Lesson) => {
                    this.handleActionResult({'action': CRUD_ACTIONS.UPDATE, 'content': res});
                },
                (res: HttpErrorResponse) => this.onError(res)
            );
        }
        this.alertService.error(error.error, null, null);
    }

    loadNews() {
        this.newsArticleService.findValidByDate({showInLessonsPage: true}).subscribe(
            (res: HttpResponse<NewsArticle[]>) => this.onNewsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    onNewsSuccess(response: any, headers): void {
        this.news = response;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.component.ts